/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

/**
 * @module
 * @description
 * Entry point for all public APIs of the forms package.
 */
export {AbstractControlDirective,AbstractFormGroupDirective,CheckboxControlValueAccessor,ControlContainer,ControlValueAccessor,NG_VALUE_ACCESSOR,COMPOSITION_BUFFER_MODE,DefaultValueAccessor,Form,NgControl,NgControlStatus,NgControlStatusGroup,NgForm,NgModel,NgModelGroup,RadioControlValueAccessor,FormControlDirective,FormControlName,FormGroupDirective,FormArrayName,FormGroupName,NgSelectOption,SelectControlValueAccessor,SelectMultipleControlValueAccessor,AsyncValidator,AsyncValidatorFn,CheckboxRequiredValidator,EmailValidator,MaxLengthValidator,MinLengthValidator,PatternValidator,RequiredValidator,ValidationErrors,Validator,ValidatorFn,FormBuilder,AbstractControl,FormArray,FormControl,FormGroup,NG_ASYNC_VALIDATORS,NG_VALIDATORS,Validators,VERSION,FormsModule,ReactiveFormsModule} from './src/forms';

// This file only reexports content of the `src` folder. Keep it that way.



// WEBPACK FOOTER //
// ../../../../packages/forms/public_api.ts